import { SVGProps } from 'react';

export default function EyeShow(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg {...props} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M21.268 10.8033C19.1237 8.4442 15.5672 5.95051 12.0002 6.00077C8.43311 5.9497 4.8766 8.44501 2.73231 10.8033C2.43838 11.132 2.27588 11.5574 2.27588 11.9983C2.27588 12.4392 2.43838 12.8646 2.73231 13.1932C4.85147 15.5272 8.35772 17.999 11.8696 17.999H12.1193C15.6434 17.999 19.1489 15.5272 21.2705 13.1924C21.564 12.8636 21.726 12.4382 21.7256 11.9974C21.7251 11.5567 21.5622 11.1315 21.268 10.8033ZM8.27097 11.9999C8.27097 11.2623 8.48969 10.5413 8.89946 9.92808C9.30923 9.31482 9.89165 8.83684 10.5731 8.55458C11.2545 8.27233 12.0043 8.19848 12.7277 8.34237C13.4511 8.48626 14.1156 8.84143 14.6371 9.36297C15.1586 9.88451 15.5138 10.549 15.6577 11.2724C15.8016 11.9958 15.7277 12.7456 15.4455 13.427C15.1632 14.1084 14.6853 14.6908 14.072 15.1006C13.4587 15.5104 12.7377 15.7291 12.0002 15.7291C11.0111 15.7291 10.0626 15.3362 9.36323 14.6368C8.66387 13.9375 8.27097 12.9889 8.27097 11.9999Z'
        fill='white'
        fillOpacity='0.43'
      />
      <path
        d='M12.0002 13.6213C12.8956 13.6213 13.6216 12.8954 13.6216 11.9999C13.6216 11.1044 12.8956 10.3785 12.0002 10.3785C11.1047 10.3785 10.3788 11.1044 10.3788 11.9999C10.3788 12.8954 11.1047 13.6213 12.0002 13.6213Z'
        fill='white'
        fillOpacity='0.43'
      />
    </svg>
  );
}
